import Vue from 'vue'
import axios from 'axios'
import Dialog from '../components/dialogGeneral.vue'
import Loading from '../components/loadScreen.vue'
import Modal from '../components/modalAutorizacion.vue'
require('es6-promise').polyfill()

import modalMotivo from '../components/modalMotivo.vue'
import modalListado from '../components/modalListadoAut.vue'
import { setTimeout } from 'timers';

var loading = new Vue({ el: '#loading', mixins: [Loading] })
var dialog = new Vue({ el: '#dialogo', mixins: [Dialog] })

//instancia que traera los datos del postulante

var resultado = new Vue({
    el: "#resultadoPost",
    data: {
        textResultado: "",
        showTextResultado: false,
    },
})

var postulanteGlobal = new Vue({
    el: '#informacionPersonal',
    data: {
        cerrarSession: false,
        modificarSol: false,
        postulante: [],
        listadoSolicitudes: [],
        listadoAutorizaciones: [],
        listadoAutorizacionesSolicitadas: [],
        msgExcepcion: false,
        btnPostular: true,
        blockPostular:true,
    },
    computed: {
        btnHabilitado: function () {
            return this.motivoEliminacion.length > 0 ? false : true;
        }
    },
    methods: {
        ConstructorPortal: function () {

            loading.showLoad("Cargando portal ...");
            
            axios.post('/Portal/ConstructorPortalPostulacion/').then((response) => {

                loading.hideLoad();

                var respuesta = response.data;
                listado.estadoFinalizado = respuesta.estadoFinal;
                if (respuesta.resultado == "exito") {

                    if (respuesta.mostrarFechaRes) {
                        resultado.showTextResultado = true;

                      // var Fecha = new Date(resultado.fechaResultado);                        

                        resultado.textResultado = "El resultado de su postulaci\u00F3n estar\u00E1 el mes de <strong>" + respuesta.fechaResultado + ".</strong>";
                    }

                    listado.MensajeModificacion = respuesta.MensajeModificacion;
                    
                    //INFORMACION PERSONA
                    this.postulante = respuesta.persona;

                    listado.listadoSol = respuesta.listadoSolicitudes;
                    listado.listadoAut = respuesta.listadoAutorizaciones;
                    listado.listadoAutoSol = respuesta.listadoAutorizacionesSolicitadas;
                    listado.showListado = false;
                    for (var i in listado.listadoAutoSol) {
                        if (listado.listadoAutoSol[i].Estado == -1) {
                            listado.showListado = true;
                        }
                    }

                    
                    if (listado.listadoSol.length > 0) {
                        if (listado.listadoSol[0].IdEstado == 0) {
                            this.modificarSol = false;
                            listado.modificarSol = false;
                        } else {
                            listado.modificarSol = true;
                            this.modificarSol = true;
                        }
                    } else {
                        this.modificarSol = false;
                        listado.modificarSol = false;

                    }
                    
                    this.blockPostular = respuesta.blockPostular;

                } else {

                    switch (respuesta.resultado) {
                        case "excepcion":
                        case "nosesion":
                            dialog.showDialog("Error", respuesta.mensaje, "../Login/Login");
                            break;
                    }
                }
            });

        },
        ValidarPostulante: function () {
            loading.showLoad("Cargando información...");

            axios.post('/Portal/ValidarPostulante/').then((response) => {
                var resultado = response.data.resultado;
                var mensaje = response.data.mensaje;

                loading.hideLoad();
                if (resultado == "exito") {
                    window.location.href = mensaje;

                } else if (resultado == "invalido") {

                    dialog.showDialog("Postulación en línea", mensaje, response.data.redireccion);

                } else if (resultado == "excepcion") {
                    dialog.showDialog("Error", mensaje, "../Login/Login");

                } else if (resultado == "observacion") {
                    dialog.showDialog("Postulación en línea", mensaje, "");
                }

            });
        },
    },
    mounted: function () {
        this.ConstructorPortal();
    }
});

var listado = new Vue({
    el: '#listado',
    components: {
        'modal_motivo': modalMotivo,
        'modal': Modal,
        'listadoautorizaciones': modalListado,
    },
    data: {
        listadoSol: '',
        listadoAut: '',
        listadoAutoSol: '',
        autPersonal: false,
        estadoFinalizado: '',
        link: '',
        modificarSol: false,
        bShowModal: false,
        oMotivo: {
            accion: 0,
            sol_id: 0,
            estado: 0,
            razon: "",
        },
        showEliSol: false,
        showListado: false,
        accion: 0,
        MensajeModificacion: '',
    },
    watch: {
        showEliSol: {
            immediate: true,
            handler: function (val, oldVal) {
                if (!val) {
                    document.ontouchmove = function (e) { return true; }
                    document.body.style.overflow = "inherit";
                } else {
                    document.ontouchmove = function (e) { e.preventDefault(); }
                    document.body.style.overflow = "hidden";
                }
            }
        }
    },
    methods: {
        cerrarSession: function () {
            axios.post('/Login/cerrarSession/').then(response => {
                if (response.data == "True") {
                    window.location = "../";
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        DescargarDoc: function (solId) {
            this.link = "/Util/descargarPDF?idSol=" + solId;
            window.location.href = this.link;
        },
        DescargarRenuncia: function (solId) {
            this.link = "/Util/descargarRenunciaPDF?idSol=" + solId;
            window.location.href = this.link;
        },
        MostrarMotivo: function (sol, accion) {

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

            this.bShowModal = true;
            this.accion = accion;

            this.oMotivo.accion = accion;
            this.oMotivo.sol_id = sol;


        },
        AccionSolicitud: function (emisario) {
            if (emisario.enviar == true) {
                switch (this.oMotivo.accion) {
                    case 1:
                        this.Modificar(this.oMotivo.sol_id, emisario.motivo, 1);
                        break;
                    case 2:
                        this.Eliminar(this.oMotivo.sol_id, emisario.motivo);
                        break;
                    case 3:
                        this.Renunciar(this.oMotivo.sol_id, emisario.motivo);
                        break;
                }
            }
        },
        Modificar: function (idSol, motivo, accion) {

            if (accion == 1) {
                loading.showLoad("Procesando motivo ...");
            }

            var data = {
                idSol: idSol,
                motivo: motivo,
                accion: accion,
            };

            var parametros = new FormData();
            parametros.append("json", JSON.stringify(data));
            
            axios({
                method: 'POST',
                url: '/Portal/ModificarPostulacion/',
                data: parametros,
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then((response) => {
                var resultado = response.data.resultado;
                var mensaje = response.data.mensaje;

                if (resultado == "exito") {
                    window.location.href = mensaje;

                } else if (resultado == "invalido") {
                    loading.hideLoad();
                    dialog.showDialog("Invalido", mensaje, "");

                } else if (resultado == "excepcion") {
                    loading.hideLoad();
                    dialog.showDialog("Error", mensaje, "");

                }

            });

        },
        Eliminar: function (idSol, motivo) {

            loading.showLoad("Eliminando solicitud ...");

            var data = {
                idSol: idSol,
                motivo: motivo
            };


            var dato = new FormData();
            dato.append("json", JSON.stringify(data));


            axios({
                method: 'POST',
                url: '/Portal/EliminarPostulacion/',
                data: dato,
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then((response) => {

                

                var data = response.data;
                switch (data.resultado) {
                    case "exito":
                        loading.hideLoad();
                        dialog.showDialog("Postulación en línea", "Eliminación completada exitosamente", data.redireccion);
                        break;
                    case "excepcion":
                        loading.hideLoad();
                        dialog.showDialog("Error", data.mensaje, "");

                        break;
                }


            }).catch((error) => {
                console.log(error);
            });


        },
        Renunciar: function (idSol, motivo) {
            
            loading.showLoad("Procesando renuncia ...");

            var data = {
                idSol: idSol,
                motivo: motivo,
            };

            var dato = new FormData();
            dato.append("json", JSON.stringify(data));
                
            axios({
                method: 'POST',
                url: '/Portal/RenunciarPostulacion/',
                data: dato,
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then((response) => {
                    
                var data = response.data;
                
                switch (data.resultado) {
                    case "exito":

                        this.DescargarRenuncia(data.idSol);
                        setTimeout(function () {
                            loading.hideLoad();
                            dialog.showDialog("Postulación en línea", "Renuncia completada exitosamente", data.redireccion);
                        }, 5000);

                        break;
                    case "invalido":
                        loading.hideLoad();
                        dialog.showDialog("Invalido", data.mensaje, "");
                        break;
                    case "excepcion":
                        loading.hideLoad();
                        dialog.showDialog("Error", data.mensaje, "");
                        break;
                }

                   
            }).catch((error) => {
                console.log(error);
            });

            
        },
        Autorizar: function (oAutorizacion) {

            var data = {
                idAuto: oAutorizacion.Id,
                idTipo: oAutorizacion.IdTipo
            };

            var dato = new FormData();
            dato.append("json", JSON.stringify(data));

            axios({
                method: 'POST',
                url: '/Portal/redAutorizacion/',
                data: dato,
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then((response) => {

                var resultado = response.data.resultado;
                var redireccion = response.data.redireccion;

                if (resultado = "exito") {
                    window.location = redireccion;
                }
            }).catch((error) => {
                console.log(error);
            });



        },
        Pssim: function () {
            axios.post('/Login/Pssim/').then(response => {
                var resultado = response.data.resultado;
                if (resultado == "exito") {
                }
            });
        }
    },
    mounted: function () {
    },
    beforeMount: function () {
        this.Pssim();
    }
});






// WEBPACK FOOTER //
// ./Scripts/js/portal/portal.js